import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Building05Icon, Phone01Icon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {Tooltip} from '@/components/ui/tooltip/Tooltip'
import {AgendaEventType} from '@/features/agenda/types'
import {useTranslation} from '@/translations/i18n'
import {useMemo} from 'react'

export const AgendaEventSectorIcon = ({
    sector,
    size = 14,
    accessTypes
}: {
    size: number
    sector?: AgendaEventType['sector']
    accessTypes?: string
}) => {
    const {t} = useTranslation()
    const triggerProps = useMemo(() => ({tabIndex: -1}), [])

    if (sector == 'outpatient') {
        return (
            <Tooltip
                content={<TooltipContent sector={t('agenda:event_outpatient')} accessTypes={accessTypes} />}
                variant="light"
                triggerProps={triggerProps}
            >
                <Building05Icon size={size} />
            </Tooltip>
        )
    }

    if (sector == 'domiciliary') {
        return (
            <Tooltip
                content={<TooltipContent sector={t('agenda:event_domiciliary')} accessTypes={accessTypes} />}
                variant="light"
                triggerProps={triggerProps}
            >
                <Phone01Icon size={size} />
            </Tooltip>
        )
    }

    return null
}

const TooltipContent = ({sector, accessTypes}: {sector: string; accessTypes?: string}) => {
    return (
        <Flexbox direction="column" align="flex-start">
            <Text size="textSm" weight="500" palette="neutral" shade="950">
                {sector}
            </Text>
            <Text size="textSm" weight="400" palette="neutral" shade="600">
                {accessTypes}
            </Text>
        </Flexbox>
    )
}
